import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import styles from "../../cards.module.scss"
import { getConstant } from '../../../../utils/constants';
function PropertyItem({ property, handleClickProperty, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickProperty}>
      <img
        className={styles.projectImage}
        src={property.main_img ? property.main_img.file : getImage('img-ph.png')}
        alt={property.main_img ? property.main_img.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{property.title}</p>
          <span className={styles.subtitle}>
            {property.dept}
          </span>

          <span className={styles.subtitle}>
            {property.surface} ha, {property.price} €</span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: property.availabilty ? 'Disponible' : 'Non disponible',
              bgColor: property.availabilty ? 'bg-green-700' : 'bg-green-950'
            }}
            rounded
          />
          <Tag
            tag={{
              label: property.sold ? 'Vendu' : 'Non vendu',
              bgColor: property.sold ? 'bg-purple-700' : 'bg-purple-950'
            }}
            rounded
          />
          <Tag
            tag={{
              label: getConstant('shared.draftTypes', property.is_draft).label,
              bgColor: getConstant('shared.draftTypes', property.is_draft).bgColor
            }}
            rounded
          />
        </div>
      </div>
    </div >
  );
}

export default PropertyItem;
